import { render, staticRenderFns } from "./ChatBubble.vue?vue&type=template&id=0958e852&scoped=true"
import script from "./ChatBubble.vue?vue&type=script&lang=js"
export * from "./ChatBubble.vue?vue&type=script&lang=js"
import style0 from "./ChatBubble.vue?vue&type=style&index=0&id=0958e852&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0958e852",
  null
  
)

export default component.exports